import React from 'react';

const PageTitleNews = () => {
    return (
        <div id="page-title">
            <div className="wrapper text-center">
                <h1 className="large">News</h1>
            </div>
        </div>
    );
};

export default PageTitleNews;
